var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"opened":_vm.opened,"question":_vm.question,"okLabel":_vm.okLabel,"cancelLabel":_vm.cancelLabel,"reject":_vm.reject,"accept":_vm.accept})],2)}
var staticRenderFns = []

export { render, staticRenderFns }